import script from "./OverviewMarkets.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewMarkets.vue?vue&type=script&setup=true&lang=js"

import "./OverviewMarkets.vue?vue&type=style&index=0&id=dbce6e6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbce6e6c"]])

export default __exports__